var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.394,
    height: 30.394,
    viewBox: "0 0 30.394 30.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location",
    transform: "translate(-408.627 -764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224749",
    "data-name": "Path 224749",
    d: "M24.695,30.394H5.7a5.7,5.7,0,0,1-5.7-5.7V5.7A5.7,5.7,0,0,1,5.7,0h19a5.7,5.7,0,0,1,5.7,5.7v19A5.7,5.7,0,0,1,24.695,30.394Zm0,0",
    transform: "translate(408.627 764)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "location-2",
    "data-name": "location",
    transform: "translate(418.625 771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224299",
    "data-name": "Path 224299",
    d: "M38.923,6.31a5.634,5.634,0,0,0-5.634,5.634c-.033,5.375,5.634,12.042,5.634,12.042s5.667-6.667,5.634-12.042A5.634,5.634,0,0,0,38.923,6.31Zm0,8.024a2.39,2.39,0,1,1,2.39-2.39A2.39,2.39,0,0,1,38.923,14.334Z",
    transform: "translate(-33.289 -6.31)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_725",
    "data-name": "Ellipse 725",
    cx: 2.846,
    cy: 2.846,
    rx: 2.846,
    ry: 2.846,
    transform: "translate(2.694 2.49)",
    fill: "#e8e8e8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.12aa258e5661b512bfcd05e5b255fed5.svg";
export { ForwardRef as ReactComponent };